import styled from 'styled-components';

import { ThemeProps as Prop } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

export const StyledScrollIndicator = styled.div`
  position: absolute;
  left: calc(50% - 25px);
  bottom: ${({ $bottomOffset }) => $bottomOffset}px;
  z-index: 1001;
  transition: opacity 0.5s ease-in-out;

  &.visible {
    opacity: 1;
  }

  &.hidden {
    opacity: 0;
    animation-play-state: paused;
  }

  svg {
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.ICON, $component, $colorProfile)};
    fill: ${({ $colorProfile, $component }) => themeUtil(Prop.ICON, $component, $colorProfile)};
  }
`;
